export default "__VITE_ASSET__fb41fe42__"